module.exports = "<img class=\"customImage\" src=\"{{imageUrl}}\">";